import React from "react";

import { Tooltip } from "@material-ui/core";
import InvoiceNewIcon from "@material-ui/icons/RadioButtonUnchecked";
import InvoicePaidIcon from "@material-ui/icons/CheckCircleOutline";
import InvoicePartiallyPaidIcon from "@material-ui/icons/RemoveCircle";
import InvoiceOverdueIcon from "@material-ui/icons/Error";
import InvoicePendingIcon from "@material-ui/icons/RadioButtonUnchecked";
import InvoiceVoidIcon from "@material-ui/icons/NotInterested";
import { green, orange } from "@material-ui/core/colors";

import { ExternalStatus, InvoiceStatus } from "../../../utils/constants";

import { ExternalStatusIcon } from "../../../components/common/ExternalStatusIcon";
import { InvoicesIcon, OverdueIcon } from "../../../components/common/iconography";

export const InvoiceStatusIcon = ({ record }) => {
  if (!record?.status) return null;

  if (
    record?.externalStatus &&
    record.externalStatus !== ExternalStatus.SYNCED
  ) {
    return <ExternalStatusIcon record={record} />;
  }

  const isPartiallyPaid =
    record.balance > 0 && record.balance < record.total;

  const icon = () => {
    switch (true) {
      case record.status === InvoiceStatus.PAID:
        return (
          <Tooltip title="Paid/Completed" placement="left" arrow>
            <InvoicePaidIcon style={{ color: green[700] }} />
          </Tooltip>
        );
      // Overdue outranks a partial payment: money still late is the signal
      case record.overDue:
        return (
          <Tooltip
            title={isPartiallyPaid ? "Overdue · Partially Paid" : "Overdue"}
            placement="left"
            arrow
          >
            <OverdueIcon style={{ color: orange[700] }} />
          </Tooltip>
        );
      case isPartiallyPaid:
        return (
          <Tooltip title="Partially Paid" placement="left" arrow>
            <InvoicePartiallyPaidIcon style={{ color: orange[700] }} />
          </Tooltip>
        );
      case record.status === InvoiceStatus.PENDING:
        return (
          <Tooltip title="Sent/Pending" placement="left" arrow>
            <InvoicePendingIcon />
          </Tooltip>
        );
      case record.status === InvoiceStatus.OVERDUE:
        return (
          <Tooltip title="Overdue" placement="left" arrow>
            <InvoiceOverdueIcon style={{ color: orange[700] }} />
          </Tooltip>
        );
      case record.status === InvoiceStatus.VOID:
        return (
          <Tooltip title="Voided" placement="left" arrow>
            <InvoiceVoidIcon color="action" />
          </Tooltip>
        );
      default:
        return (
          <Tooltip title="Draft" placement="left" arrow>
            <InvoiceNewIcon />
          </Tooltip>
        );
    }
  };

  return icon();
};
